import * as Colors from "../../../../../../globalStyles/environmentColors";

export const title = {
    textAlign: "center"
};

export const menuLink = {
    textAlign: "center",
    cursor: "pointer"
};

export const menuLinkSelected = {
    textAlign: "center",
    color: Colors.accent,
    borderBottom: `3px solid ${Colors.accent}`,
    cursor: "pointer"
};

export const subNavBar = {
    display: "flex",
    flexDirection: "column"
};

export const mainBody = {
    flex: "1",
    overflowY: "scroll",
    overflowX: "hidden"
};
